define([
	"dojo/_base/declare",
	"csi/expander/Widget",
	"Apparel/StructureItemMixin"
], function(declare,Expander,StructureItemMixin) {

	return declare([Expander, StructureItemMixin], {
		_resolveView: function() {
			// summary: resolve view path and/or filters
			this._resolveViewPath(this);
			this._resolveViewFilter(this);
			this.inherited(arguments);
		}
	});
});